export default {
  hero_label: 'News',
  hero_title: 'お知らせ',
  hero_subtitle: 'AIX JAPANの最新情報をお届けします。',
  cat_all: 'ALL',
  cat_pressrelease: 'プレスリリース',
  cat_service: 'サービス',
  cat_event: 'イベント',
  cat_award: '受賞',
  cat_recruit: '採用',
  cat_media: 'メディア',
  read_more: '詳しく見る',
  prev_article: '前の記事',
  next_article: '次の記事',
  back_to_list: 'お知らせ一覧へ戻る',
  news: [
    {
      id: 1,
      date: '2026.04.01',
      category: 'お知らせ',
      title: 'コーポレートサイトをリニューアル',
      excerpt: '事業拡大およびブランドリニューアルに伴い、コーポレートサイトを全面リニューアルいたしました。より見やすく、情報を充実させた新サイトをぜひご覧ください。',
      body: '事業拡大およびブランドリニューアルに伴い、AIX JAPAN株式会社のコーポレートサイトを全面リニューアルいたしました。\n\n今回のリニューアルでは、サービス内容の再整理・情報設計の見直しを行い、お客様により分かりやすく弊社の強みと実績をご覧いただける構成に一新しました。スマートフォン・タブレットでも快適にご覧いただけるレスポンシブデザインを採用し、最新の事例や採用情報もより充実した内容でお届けします。\n\n引き続き、AIX JAPANはAI活用・DX推進のパートナーとして、企業の変革と成長を全力でサポートしてまいります。新しいサイトをぜひご覧ください。',
      image: '/assets/aix_news_r01.jpg'
    },
    {
      id: 2,
      date: '2026.04.01',
      category: 'プレスリリース',
      title: '事業拡大に伴い、オフィスを虎ノ門から新宿に移転',
      excerpt: '事業規模の拡大に伴い、オフィスを虎ノ門から新宿に移転いたしました。より広い拠点で、一層充実したサービスを提供してまいります。',
      body: 'AIX JAPAN株式会社は、2026年4月1日付けで本社オフィスを虎ノ門から新宿に移転いたしました。\n\n創業以来、AI活用コンサルティング・DX推進支援を中心に事業を拡大してきた結果、チーム規模の拡充および新規プロジェクトへの対応力強化のため、より広い拠点への移転を決定いたしました。\n\n新オフィスは交通アクセスが良好で、クライアント様とのミーティングや各種ワークショップをこれまで以上にスムーズに行える環境を整えております。引き続き変わらぬご支援のほど、よろしくお願い申し上げます。\n\n【新オフィス所在地】\n〒160-0023 東京都新宿区西新宿3-2-9 新宿ワシントンホテルビル本館 2F',
      image: '/assets/aix_news_r02.jpg'
    },
    {
      id: 3,
      date: '2026.02.16',
      category: 'プレスリリース',
      title: '法人名を株式会社Japan ConsultingからAIX JAPAN株式会社に変更',
      excerpt: 'AI領域への注力と事業の方向性をより明確に示すため、社名を株式会社Japan ConsultingからAIX JAPAN株式会社に変更いたしました。',
      body: '2026年2月16日付けで、弊社の商号を「株式会社Japan Consulting」から「AIX JAPAN株式会社」へと変更いたしました。\n\n創業以来、企業のAI活用・DX推進を支援するコンサルティングを主軸に事業を展開してまいりましたが、今後はさらにAI（人工知能）領域に特化した事業展開を加速させるにあたり、社名にその方向性を明確に表現することといたしました。\n\n「AIX JAPAN」の "X" は "Transformation（変革）" を意味し、AIを通じて日本の産業・社会に革新をもたらすという弊社のミッションを体現しています。\n\n今後とも変わらぬご支援のほど、よろしくお願い申し上げます。',
      image: '/assets/aix_news_r03.jpg'
    },
    {
      id: 4,
      date: '2025.10.29',
      category: 'イベント',
      title: '生成AI World（2025/10/29〜30）に出展・登壇',
      excerpt: '2025年10月29日〜30日に開催された生成AI Worldに出展するとともに、セッションに登壇し、AI活用の最新事例と知見を共有いたしました。',
      body: '2025年10月29日〜30日に東京にて開催された「生成AI World」において、AIX JAPANは展示ブースを出展するとともに、代表がセッションスピーカーとして登壇いたしました。\n\nブースでは、AIX JAPANが提供するAI活用コンサルティングサービス・DX支援の実績をパネルおよびデモンストレーションにて紹介し、来場された多くの企業担当者・経営者の方々と活発な情報交換ができました。\n\nまた登壇セッションでは「中小企業・地方自治体へのAI導入事例と成功の鍵」をテーマに、実際のプロジェクトを通じて得た知見とアプローチをご紹介し、大変好評をいただきました。今後もこのような場を通じて、日本全国でのAI活用促進に貢献してまいります。',
      image: '/assets/aix_news_r04.jpg'
    },
    {
      id: 5,
      date: '2025.08.29',
      category: 'サービス',
      title: '福島市向けAI研修セミナーを実施',
      excerpt: '2025年8月29日、福島市を対象としたAI研修セミナーを実施いたしました。自治体職員の方々にAI活用の基礎から実践的な活用方法までをお伝えしました。',
      body: '2025年8月29日、AIX JAPANは福島市役所と連携し、市職員の方々を対象としたAI研修セミナーを実施いたしました。\n\n今回のセミナーは「AI入門〜自治体業務への実践活用」をテーマに設定し、AI・生成AIの基礎知識から、文書作成・データ分析・市民対応の効率化に至るまで、実際の自治体業務に即した内容でプログラムを構成しました。\n\n参加された職員の方々からは「AIのイメージが変わった」「すぐに業務に活かせる内容だった」「もっと詳しく学びたい」など多くのポジティブなフィードバックをいただきました。\n\nAIX JAPANは今後も自治体・公共機関へのAI活用支援を積極的に推進し、地域のデジタル変革に貢献してまいります。',
      image: '/assets/aix_news_r05.jpg'
    },
    {
      id: 6,
      date: '2025.07.24',
      category: 'イベント',
      title: 'Tech Beat Shizuoka 2025（2025/7/24〜26）に出展・登壇',
      excerpt: '2025年7月24日〜26日に開催されたTech Beat Shizuoka 2025に出展・登壇いたしました。地域のスタートアップ・企業との交流を通じ、AIの可能性を広く発信しました。',
      body: '2025年7月24日〜26日、静岡県で開催された「Tech Beat Shizuoka 2025」にAIX JAPANは出展ブース・登壇者として参加いたしました。\n\nTech Beat Shizuokaは地域のスタートアップ・テクノロジー企業が一堂に会するイベントで、今年は過去最多の来場者を記録。AIX JAPANのブースにも多くの企業・自治体担当者の方々にお立ち寄りいただきました。\n\n登壇セッションでは「地方企業のAI活用最前線」をテーマに、地方企業ならではの課題とAIによる解決事例を具体的にご紹介しました。地域の産業振興・課題解決においてAIが果たせる役割の大きさを、参加者の皆様と共有できた意義あるイベントとなりました。',
      image: '/assets/aix_news_r06.jpg'
    },
    {
      id: 7,
      date: '2025.05.08',
      category: 'イベント',
      title: 'Start Up Japan EXPO（2025/5/8〜10）に出展',
      excerpt: '2025年5月8日〜10日に開催されたStart Up Japan EXPOに出展いたしました。多くの起業家・投資家・企業の皆様とAI活用の未来についてご議論できました。',
      body: '2025年5月8日〜10日、東京で開催された「Start Up Japan EXPO」にAIX JAPANは出展いたしました。\n\n本EXPOは国内最大規模のスタートアップイベントのひとつで、今年も3日間で数千名を超える起業家・投資家・大企業のイノベーション担当者が来場。AIX JAPANのブースでは、AI活用コンサルティングの最新事例を紹介したほか、スタートアップ向けのAI導入支援プログラムについてもご案内しました。\n\n多くの方々とAI技術が切り拓くビジネスの未来についてディスカッションができ、新たなパートナーシップのきっかけとなる出会いも多数生まれました。今後のAI×新規事業開発の展開にご期待ください。',
      image: '/assets/aix_news_r07.jpg'
    },
    {
      id: 8,
      date: '2025.01.23',
      category: 'プレスリリース',
      title: '虎ノ門にて株式会社Japan Consultingを創業',
      excerpt: '2025年1月23日、東京・虎ノ門にて株式会社Japan Consultingを創業いたしました。AI活用コンサルティングを通じ、企業の変革と成長を支援してまいります。',
      body: '2025年1月23日、東京都港区虎ノ門において、株式会社Japan Consultingを創業いたしました。\n\n弊社は「AIとテクノロジーの力で、日本のあらゆる産業に変革をもたらす」というビジョンのもと、企業のAI活用・DX推進を支援するコンサルティングサービスを提供するために設立されました。\n\n創業チームはAI研究・経営コンサルティング・システム開発・クリエイティブディレクションなど多彩な専門性を持つメンバーで構成されており、お客様の課題に対して多角的かつ実践的なアプローチで取り組んでまいります。\n\n「AI革命の恩恵をすべての企業・社会へ」という思いを胸に、事業を力強く推進してまいります。今後ともどうぞよろしくお願い申し上げます。',
      image: '/assets/aix_news_r08.jpg'
    }
  ]
};